import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import { useMarkAsShippedCarriers } from '../../../hooks/carrier';

import { testId } from 'ui-components/services/testid-service';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import GetCarrierDisplayName from '../../../../../components/data-driven-logo/get-carrier-display-name';

import { MarkAsShippedContext } from '../../../context';
import { MARK_AS_SHIPPED_CARRIER_ID } from '../../../constants';
import { stopPropagation } from '../../../helper';

import style from '../style.module.less';

const messages = defineMessages({
  carrierDropdownPlaceholder: {
    description: 'Placeholder text for mark as shipped carrier drpodown',
    defaultMessage: 'Select One...',
    id: 'Yr3eNM',
  },
});

const Carrier = ({ fulfillmentPlanId }) => {
  const intl = useIntl();
  const {
    fulfillmentPlans: { [fulfillmentPlanId]: { carrierId, disableCarrierDropdown } = {} },
    updateFulfillmentPlan,
  } = useContext(MarkAsShippedContext);

  const carriers = useMarkAsShippedCarriers();
  const selectedCarrier = carriers.find((carrier) => carrier.carrierId === carrierId);
  const selectedCarrierName = GetCarrierDisplayName(carrierId);
  const selectedCarrierNameTranslated = intl.formatMessage(selectedCarrierName, selectedCarrierName.values);

  const defaultDropdownText = intl.formatMessage(messages.carrierDropdownPlaceholder);

  return (
    <div onClick={stopPropagation} onScroll={stopPropagation}>
      <DropdownMenu disabled={disableCarrierDropdown} {...testId('mark-as-shipped-carrier')} variant='form'>
        <DropdownMenuToggler
          className={style['dropdown-toggler']}
          title={selectedCarrier ? selectedCarrierNameTranslated : defaultDropdownText}
        >
          {selectedCarrier ? selectedCarrierNameTranslated : defaultDropdownText}
        </DropdownMenuToggler>
        <DropdownMenuItem onClick={() => updateFulfillmentPlan(fulfillmentPlanId, MARK_AS_SHIPPED_CARRIER_ID, '')}>
          {selectedCarrier ? selectedCarrierNameTranslated : defaultDropdownText}
        </DropdownMenuItem>
        {carriers.map((carrier) => {
          const carrierNameMessage = GetCarrierDisplayName(carrier.carrierId);
          return (
            <DropdownMenuItem
              key={carrier.carrierId}
              onClick={() => updateFulfillmentPlan(fulfillmentPlanId, MARK_AS_SHIPPED_CARRIER_ID, carrier.carrierId)}
            >
              {intl.formatMessage(carrierNameMessage, carrierNameMessage.values)}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenu>
    </div>
  );
};

Carrier.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default Carrier;
